
import applicants from './applicants';

export default {
  applicants,
};
